import Axios from '../baseApi';

export default {
  async fetchByCategory(categoryId) {
    return await Axios.get(`api-master-data/pig-prices/v1/${categoryId}`);
  },
  async fetchCurrent(categoryId, priceId) {
    return await Axios.get(`api-master-data/pig-prices/v1/current/${categoryId}/${priceId}`);
  },
  async fetchByDate(categoryId, priceId, date) {
    return await Axios.get(`api-master-data/pig-prices/v1/${categoryId}/${priceId}/${date}`);
  },
  async update(form) {
    return await Axios.put(`api-master-data/pig-prices/v1`, form);
  },
  async add(form) {
    return await Axios.post(`api-master-data/pig-prices/v1`, form);
  },
  async delete(priceId) {
    return await Axios.delete(`api-master-data/pig-prices/v1/${priceId}`);
  },
  async fillUp(categoryId, till) {
    return await Axios.post(`api-master-data/pig-prices/v1/fill-up/${categoryId}?till=${till}`);
  }
}
